import { formatApiErrorDetail } from '../../auth';

export const siteApi = async (path, options = {}) => {
  const controller = new AbortController();
  let timedOut = false;
  const cancel = () => controller.abort();
  const timeout = setTimeout(() => { timedOut = true; cancel(); }, 15000);
  options.signal?.addEventListener('abort', cancel, { once: true });
  if (options.signal?.aborted) cancel();
  try {
    const response = await fetch(`${process.env.REACT_APP_BACKEND_URL}/api${path}`, {
      ...options, signal: controller.signal,
      headers: { Accept: 'application/json', 'Content-Type': 'application/json', Authorization: `Bearer ${localStorage.getItem('gv_token') || ''}`, ...options.headers },
    });
    let data;
    try { data = await response.json(); }
    catch (failure) {
      if (failure.name === 'AbortError') throw failure;
      throw new Error(`The server returned an unexpected response (HTTP ${response.status}). Please retry. If it continues, the site connection needs attention.`);
    }
    if (!response.ok) throw new Error(formatApiErrorDetail(data.detail));
    return data;
  } catch (failure) {
    if (timedOut) throw new Error('The request timed out. Reload and try again.');
    throw failure;
  } finally {
    clearTimeout(timeout); options.signal?.removeEventListener('abort', cancel);
  }
};
export const credits = (minor) => `${((minor || 0) / 100).toLocaleString(undefined, { minimumFractionDigits: 2, maximumFractionDigits: 2 })} V`;
export const timestamp = (value) => value ? new Date(value).toLocaleString() : '—';